import { memo } from 'react';
import { Box } from '@material-ui/core';
import SHighlightText from '../../shighlight-text';

interface STreeNodeLabelProps<T> {
  item: T;
  icon?: JSX.Element;
  title: string;
  search?: string;
  selected?: boolean;
  actions?: (item: T) => JSX.Element;
}

const STreeNodeLabel = <T,>({
  item,
  title,
  search,
  icon,
  selected,
  actions
}: STreeNodeLabelProps<T>) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    height={24}>
    <SHighlightText
      value={title}
      searchQuery={search}
      highlightColor={selected && search ? '#fff' : undefined}
      fontColor="inherit"
      size="sm"
      lineHeight="20px"
    />
    {actions?.(item)}
    {icon}
  </Box>
);

export default memo(STreeNodeLabel);
